import dayjs from "dayjs";
import { FC } from "react";
import { SalesSKUInvoice } from "tm-shared/types";

import SumIcon from "@/assets/icons/sum.svg";
import FlexContainer from "@/components/FlexContainer";
import { PrimaryText, SecondaryText } from "@/components/Typography/Styled";

import { StyledISIBlock, StyledISIModal, StyledISISum } from "./Styled";

interface InvoiceSKUInfoModalProps {
    modalKey: string;
    isOpen: boolean;
    onClose: () => void;
    invoice: SalesSKUInvoice;
}

export const InvoiceSKUInfoModal: FC<InvoiceSKUInfoModalProps> = ({
    isOpen,
    onClose,
    invoice,
}) => {
    if (!invoice) return null;

    const { fop, marketAddress, invoiceCreatedAt, amount } = invoice;
    const formattedTime = invoiceCreatedAt
        ? dayjs(invoiceCreatedAt).format("HH:mm:ss")
        : "";

    return (
        <StyledISIModal
            open={isOpen}
            onOk={onClose}
            onCancel={onClose}
            centered
            footer={null}
            destroyOnClose
        >
            <FlexContainer
                width="100%"
                style={{ padding: "24px" }}
                flexDirection="column"
                justifyContent="flex-start"
                alignItems="flex-start"
            >
                <PrimaryText fontSize={16}>{invoice.invoiceId}</PrimaryText>

                <StyledISIBlock
                    alignItems="flex-start"
                    justifyContent="flex-start"
                >
                    <PrimaryText
                        fontSize={14}
                        fontWeight="500"
                        textAlign="left"
                    >
                        {fop}
                    </PrimaryText>

                    <SecondaryText fontSize={14} fontWeight="400">
                        {marketAddress}
                    </SecondaryText>

                    <FlexContainer
                        width="100%"
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        <SecondaryText fontSize={14} fontWeight="400">
                            {formattedTime}
                        </SecondaryText>

                        <FlexContainer gap="4px">
                            <img src={SumIcon} alt="sum" />
                            <StyledISISum>{amount.toFixed(2)} ₴</StyledISISum>
                        </FlexContainer>
                    </FlexContainer>
                </StyledISIBlock>
            </FlexContainer>
        </StyledISIModal>
    );
};
